<div
  class="table-view d-flex flex-column align-items-stretch busy-overlay-parent"
  [ngClass]="isLoading || !appState.isReady ? 'disabled' : ''"
>
  <fes-stats-view *ngIf="statsEnabled && statGroupResults?.length"
    [statGroupResults]="statGroupResults"
    [tableColumns]="tableColumns"
    [loadStatsFn]="loadStats"
    [isVisible]="isActiveView"
    (statGroupResultChanged)="onStatGroupResultChanged($event)">
  </fes-stats-view>

  <div
    *ngIf="isLoading || !appState.isReady"
    class="font-weight-bold busy-overlay"
  >
    <i class="fa fa-spinner fa-spin"></i>&nbsp;Loading...
  </div>

  <div
    *ngIf="errorMsg"
    class="alert alert-danger d-flex flex-row justify-content-between"
  >
    <div>{{ errorMsg }}</div>
    <div class="">
      <i class="fa fa-times" role="button" (click)="errorMsg = null"></i>
    </div>
  </div>

  <div class="table-view-header-controls">
    <div *ngIf="bShowCalendar" class="mb-1">
      <app-table-view-calendar
        [defaultDateFilterResolverFn]="defaultCalendarDateFilterResolver"
        [column]="calendarColumn"
        (dateFilterChanged)="calendarDateFilterChanged($event)"
        (closeCalendar)="closeCalender($event)"
        [events]="calendarEvents$ | async"
        [groupedByDay]="groupedByDay"
      >
      </app-table-view-calendar>
    </div>
    <div *ngIf="bShowHeader" class="d-flex flex-row justify-content-between">
      <div class="d-flex flex-wrap">
        <ng-template #configModal>
          <div cdkDrag cdkDragRootElement=".modal-dialog">
          <div
            class="m-0 p-1 modal-header font-weight-bold"
            style="background-color: #cfd5ea"
            cdkDragHandle
          >
            View Configuration
            <button
              type="button"
              class="close pull-right"
              aria-label="Close"
              (click)="closeConfigModal(configComponent)"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <fes-table-view-config
              #configComponent
              [table]="this"
              [pagingEnabled]="pagingEnabled"
              (filterKeyUp)="
                $event.event.key == 'Enter' && closeConfigModal(configComponent)
              "
            >
            </fes-table-view-config>
          </div>
          <div class="m-0 p-1 modal-footer">
            <button
              class="btn btn-warning"
              (click)="closeConfigModal(configComponent)"
            >
              Close
            </button>
          </div>
        </div>
        </ng-template>

        <div class="px-sm-1 my-auto">
          <button class="btn btn-secondary btn-sm" (click)="load()">
            Search
          </button>
        </div>
        &nbsp;
        <i
          role="button"
          class="fa fa-filter my-auto px-sm-1"
          [ngClass]="populatedFilterCnt > 0 ? 'text-warning' : ' text-muted'"
          title="Table Options"
          (click)="showConfigModal(configModal)"
        >
        </i>
        <i
          role="button"
          [ngClass]="'fa fa-download' + (bDownloading ? ' blink' : '')"
          class="my-auto px-sm-1 text-muted"
          title="Download"
          (click)="!bDownloading && download()"
        >
        </i>
        <span *ngIf="statGroups?.length" role="button" class="fa-stack my-auto px-sm-1" title="Toggle Statistics View"
          (click)="onStatsEnabledClick()">
          <i class="fa fa-chart-bar fa-stack-1x" [ngClass]="!statsEnabled ? 'text-muted':'text-warning'"></i>
          <i *ngIf="statsEnabled" class="fa fa-ban fa-stack-2x" style="opacity: 0.5;"></i>
        </span>

        <ng-content select="[afterDownloadButton]"></ng-content>
        <div *ngIf="alternateViewsEnabled && meta?.alternateViews?.length" class="mx-2 p-0 smaller my-auto">
          <div class="btn-group" dropdown container="body">
          <button dropdownToggle type="button" class="btn btn-sm btn-info dropdown-toggle"
            [disabled]="isLoading">
              <span class="caret">{{selectedAlternateViewTitle||'-- Select View --'}}&nbsp;</span>
          </button>
          <!-- BsDropdownModule.forRoot() is required in each module imports section -->
          <ul *dropdownMenu role="menu"
            class="p-2 dropdown-menu" style="min-width: 5rem;">
            <li *ngIf="selectedAlternateViewName" role="menuitem"
            style="margin-bottom:2px;" title="Reset to default view">
              <button class="btn btn-light w-100 text-left text-nowrap"
                (click)="onAlternateViewChanged(undefined);">
                <i class="fa fa-eraser mr-2"></i>
                Reset
              </button>
            </li>
            <ng-container *ngFor="let v of meta.alternateViews">
            <li *ngIf="v.name !== selectedAlternateViewName" style="margin-bottom:2px;" role="menuitem">
              <button class="btn btn-light w-100 text-left text-nowrap" [ngClass]="v.cssClass"
                (click)="onAlternateViewChanged(v.name);" [attr.title]="v.description">
                <i *ngIf="v.iconClass" [ngClass]="v.iconClass" class="mr-2 text-secondary"></i>{{v.title}}
              </button>
            </li>
            </ng-container>
          </ul>
          </div>
        </div>
        <div *ngIf="filterChangeSubscription" class="p-sm-1">
          Search pending <span class="blink">...</span>
        </div>
      </div>
      <div class="d-flex flex-row justify-content-start flex-grow-1 my-auto">
        <div
          *ngIf="bulkRowActions?.length"
          class="d-flex flex-row ml-1"
        >
          <fes-table-view-action-picker
            (isProcessing)="isBulkActionProcessing = $event"
            [rowActions]="bulkRowActions"
            [recs]="checkedRecs"
            [table]="this"
          >
          </fes-table-view-action-picker>
        </div>
        <ng-content></ng-content>
      </div>
      <div class="d-flex flex-row justify-content-between">
        <div class="mx-2 my-auto text-muted font-italic">
          <span *ngIf="tableRowCount == queryRowCount"
            >Rows: {{ tableRowCount }}</span
          >
          <span *ngIf="tableRowCount != queryRowCount"
            >Filtered {{ queryRowCount }} of {{ tableRowCount }} row(s)</span
          >
          <span *ngIf="queryRowCount > 0 && pagingEnabled && pageSize">, Pages:{{ pageCount }}</span>
        </div>
        <pagination
        *ngIf="pagingEnabled && pageSize"
          class="my-auto"
          [itemsPerPage]="pageSize"
          [totalItems]="queryRowCount"
          [maxSize]="5"
          [boundaryLinks]="true"
          previousText="&lsaquo;"
          nextText="&rsaquo;"
          firstText="&laquo;"
          lastText="&raquo;"
          [(ngModel)]="pageNumber"
          (pageChanged)="onPageNumberChanged($event)"
        ></pagination>
      </div>
    </div>
  </div>
  <div class="table-view-table-wrapper">
    <table
      class="table-view-table table table-striped table-bordered table-sm"
      [ngClass]="{ 'sticky-bulk-actions': bStickyBulkActions }"
    >
      <thead>
        <tr>
          <th *ngIf="bShowBulkActionsColumn && bulkRowActions?.length"
            class="align-middle text-center">
            <input
              type="checkbox"
              class="m-auto"
              [disabled]="isBulkActionProcessing"
              [(ngModel)]="allRowsCheckboxValue"
              [ngModelOptions]="{ standalone: true }"
              (change)="onAllRowsCheckboxChange($event)"
            />
          </th>
          <ng-container *ngFor="let column of visibleColumns">
            <ng-container
              *ngIf="column.headerTemplateRef; else noHeaderTemplate"
              [ngTemplateOutlet]="column.headerTemplateRef"
              [ngTemplateOutletContext]="{ column: column, table: this }"
            >
            </ng-container>
            <ng-template #noHeaderTemplate>
              <th
                class="align-middle"
                [attr.role]="column.sortable!==false && 'button'"
                (click)="column.sortable!==false && column.name && sort(column.name)"
                [ngClass]="column.headerCellCssClass"
              >
                <div class="d-flex flex-row justify-content-between">
                  <div class="w-100 text-center">{{ column.title }}</div>
                  <i
                    *ngIf="column.name && sortColumns[0]?.key == column.name"
                    [ngClass]="
                      'fa fa-sort-' +
                      (sortColumns[0]?.order == 'ASC' ? 'up' : 'down')
                    "
                  ></i>
                  <div
                    *ngIf="
                      column.template == 'time' || column.template == 'date' || column.template == 'fulltime'
                    "
                    class="text-center my-auto ml-1"
                  >
                    <button class="btn btn-secondary p-0 px-1 m-0">
                      <i
                        class="fa fa-calendar"
                        [ngStyle]="
                          bShowCalendar &&
                          calendarColumn == column && { color: 'gold' }
                        "
                        (click)="
                          onCalendarIconClick(column); $event.stopPropagation()
                        "
                      >
                      </i>
                    </button>
                  </div>
                </div>
              </th>
            </ng-template>
          </ng-container>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="bShowFilterRow" class="filters-row">
          <td *ngIf="bShowBulkActionsColumn && bulkRowActions?.length"></td>
          <td
            *ngFor="let column of visibleColumns"
            [ngClass]="column.filterCellCssClass||'align-middle'"
            style="padding: 2px;"
          >
            <ng-container *ngIf="column.filter && column.filterable!==false">
              <ng-container *ngIf="column.filter.readonly || (bShowCalendar && calendarColumn == column); else notDisabledFilter">
                <fes-table-view-filter-input
                  *ngIf="column.filter"
                  [filter]="column.filter"
                  [disabled]="true"
                >
                </fes-table-view-filter-input>
              </ng-container>
              <ng-template #notDisabledFilter>
                <fes-table-view-filter-input-dropdown
                [title]="column.title"
                [table]="this"
                (modeSelected)="onFilterModeChanged(column, $event)">
                  <fes-table-view-filter-input
                    *ngIf="column.filter"
                    [filter]="column.filter"
                    [filterEditFn]="column.filterEditFn"
                    (keyUp)="onFilterKeyUp($event)"
                  >
                  </fes-table-view-filter-input>
                </fes-table-view-filter-input-dropdown>
              </ng-template>
            </ng-container>
          </td>
        </tr>
        <ng-container *ngIf="isActiveView&&bShowDataRows">

          <ng-content select='[tbody]'></ng-content>
          <ng-container *ngIf="!hideCellRenderer">
          <tr
            *ngFor="let record of records; index as index; trackBy: rowTrackByFn"
            [ngClass]="{ selected: record['_is_selected'] }"
            role="button"
            (dblclick)="showDetailModal(record);"
            (mouseover)="rowMouseOverEmitter.next({record, event: $event})"
            (mouseout)="rowMouseOutEmitter.next({record, event: $event})"
          >
            <td *ngIf="bShowBulkActionsColumn && bulkRowActions?.length">
              <input
                type="checkbox"
                class="m-auto"
                [disabled]="isBulkActionProcessing"
                [(ngModel)]="record['_is_checked']"
                [ngModelOptions]="{ standalone: true }"
                (change)="onRowCheckboxChange(record)"
              />
            </td>
            <ng-container
              *ngFor="let column of visibleColumns; trackBy: visibleColumnsTrackByFn"
              [ngTemplateOutlet]="
                cellRendererTmplRef || defaultColumnCellRendererTmpl
              "
              [ngTemplateOutletContext]="{
                column,
                record,
                index,
                showRequestFn,
                tableComponent: this
              }"
            >
            </ng-container>
          </tr>
          </ng-container>
        </ng-container>
      </tbody>
    </table>
  </div>
  <div class="d-flex flex-row mt-2 mx-1 justify-content-between">
    <div class="d-flex flex-row text-nowrap">
      <a href="javascript:false;" (click)="!isLoading && load()"
        [ngClass]="isLoading&&'disabled'">
        <i class="fas fa-sync"></i>&nbsp;Refresh
      </a>
    </div>
    <!-- <i *ngIf="!bShowHeader"  -->
    <div class="d-flex flex-row w-100 justify-content-end">
      <ng-content select="[footerButtonRow]"></ng-content>
      <div
        *ngIf="bulkRowActions?.length"
        class="d-flex flex-row"
      >
        <fes-table-view-action-picker
          (isProcessing)="isBulkActionProcessing = $event"
          [rowActions]="bulkRowActions"
          [recs]="checkedRecs"
          [table]="this"
        >
        </fes-table-view-action-picker>
      </div>
      <i
        role="button"
        class="text-secondary ml-1 fa fa-cog"
        (click)="bShowHeader=!bShowHeader">
      </i>
    </div>
  </div>
</div>
<ng-template
  #defaultColumnCellRendererTmpl
  let-record="record"
  let-index="index"
  let-column="column"
  let-showRequestFn="showRequestFn"
  let-tableComponent="tableComponent"
>
  <td
    fes-table-view-default-cell-renderer
    [record]="record"
    [index]="index"
    [column]="column"
    (showRequest)="showRequestFn($event)"
    [tableComponent]="tableComponent"
  ></td>
</ng-template>
